import React from 'react';
import { FinishNewsletterPopup } from '@husky-x/cc-finish-newsletter-popup';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { FinishNewsletterImageForm } from '@phx-husky/cc-finish-newsletter-image-form';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';
import { FinishProductsCards } from '@phx-husky/cc-finish-products-cards';

import {
  FinishNewsletterPopupMock,
  FinishProductCardsMock,
  FinishProductCardsMockAR,
  FinishProductDifferencesMock,
} from './custom-components-mocks';
import CustomIframeForm from './src/@husky-x/gatsby-theme-husky/components/CustomIframeForm/CustomIframeForm';
import CustomPanAnimation from './src/@husky-x/gatsby-theme-husky/components/CustomPanAnimation';
import {
  panConfigAR,
  panConfigDefault,
  panConfigSA,
  panConfigSAAR,
} from './src/@husky-x/gatsby-theme-husky/components/CustomPanAnimation/config';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'FinishProductDifferences',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMock} />,
      },
      {
        key: 'FinishProductCards',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMock} />,
      },
      {
        key: 'FinishProductCardsAR',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMockAR} />,
      },
      {
        key: 'FinishNewsletterPopup',
        component: () => <FinishNewsletterPopup {...FinishNewsletterPopupMock} />,
      },
      {
        key: 'custom_finish_newsletter_image_form',
        component: FinishNewsletterImageForm,
      },
       {
        key: 'FinishCouponPanAnimation',
        component: (props) => <CustomPanAnimation {...props} config={panConfigDefault} />,
      },
      {
        key: 'FinishCouponPanAnimationAE',
        component: (props) => <CustomPanAnimation {...props} config={panConfigAR} />,
      },
      {
        key: 'FinishCouponPanAnimationSA',
        component: (props) => <CustomPanAnimation {...props} config={panConfigSA} />,
      },
      {
        key: 'FinishCouponPanAnimationSAAR',
        component: (props) => <CustomPanAnimation {...props} config={panConfigSAAR} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
